
import axios from '@/axios.js'

export default {

  // fetchTransactionList ({ commit }, paramValue) {
  //   return new Promise((resolve, reject) => {
  //       axios.post(process.env.VUE_APP_API_GATEWAY_BASE_PATH + '/Transaction-Api/GetProviderMethodAllAsync')
  //       //axios.post('http://localhost:5001/GatewayApi/GetCustomerAll', paramValue )
  //       .then((response) => {
  //         commit('SET_TRANSACTION_LIST', response.data)
  //         resolve(response)
  //       })
  //       .catch((error) => { 
  //         commit('SET_TRANSACTION_LIST', [])
  //         reject(error)
  //       })
  //   })
  // },
    
  fetchAccountsByEmail (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/getAccountsByEmail?Email=${payload.email}&ServerType=${payload.server}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchUserAccountsByEmail (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/getUserAccountsByEmail?Email=${payload.email}&ServerType=${payload.server}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchGetDepositWithdrawalAsync ({ commit }, logins) {
    return new Promise((resolve, reject) => {
      const queryString = Object.keys(logins).map(key => 'logins=' + logins[key]).join('&')
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/GetDepositWithdrawal?${queryString}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },

  fetchTransaction (context, transactionId) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/GetTransaction?transactionId=${transactionId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getTransactionsByCustomerId ({commit}, customerId) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/GetTransactionByCustomerId?customerId=${customerId}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchGetAllTransaction ({ commit }, paramValue) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/GetTransactionAllAsync`, paramValue)
        .then((response) => {
          commit('SET_TRANSACTION_LIST', response.data.data)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  
  setTransactionSuccessfulState ({commit}, transactionId) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH}/Transaction-Api/TransactionSuccessful?transactionId=${transactionId}`)
        .catch((error) => { 
          reject(error)
        })
    })
  },

  setTTransactionFailedState ({commit}, transactionId) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH}/Transaction-Api/TransactionFailed?transactionId=${transactionId}`)
        .catch((error) => { 
          reject(error)
        })
    })
  },

  addDeposit({ commit }, paramValue) {
    console.error(paramValue)
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/AddDepositAsync`, paramValue)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error)
        })
    })
  },

  addWithdrawal({ commit }, paramValue) {
    console.error(paramValue)
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/AddWithdrawalAsync`, paramValue)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error)
        })
    })
  },

  addTransfer ({ commit }, paramValue) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/AddTransferAsync`, paramValue)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error)
        })
    })
  },

  addMt5Account ({ commit }, paramValue) {
    return new Promise((resolve, reject) => {
      console.error(paramValue)
      axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/AddMt5Account`, paramValue)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error)
        })
    })
  },

  rechargeMt4DemoAccount ({ commit }, paramValue) {
    return new Promise((resolve, reject) => {
      console.error(paramValue)
      axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/RechargeMt4DemoAccount`, paramValue)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error)
        })
    })
  },
  
  fetchProviders (context) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/GetProviderAllAsync`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  UsersGroupOp ({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/UsersGroupOperation`, params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchProviderMethod (context, providerMethodId) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/GetProviderMethod?providerMethodId=${providerMethodId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchProviderMethodsByProviderId (context, providerId) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/GetProviderMethodAllByProviderIdAsync?providerId=${providerId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchProviderMethods (context) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Transaction-Api/GetProviderMethodAllAsync`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }

}
